/**
 * Shared CRM follow-up resolution for lead list, detail, and exports.
 * Always prefer the Active follow-up row — not merely the newest by id
 * (completed follow-ups can be newer but inactive after a log is saved).
 */

export function resolveActiveFollowUp(followUps = []) {
  if (!Array.isArray(followUps) || followUps.length === 0) {
    return null;
  }
  return followUps.find((f) => f?.status === 'Active') ?? followUps[0];
}

/**
 * @deprecated Qualification saves sync into the Active follow-up record.
 * Keep CRM Active date as the single display source so list and detail match.
 */
export function resolveEffectiveFollowUpDate(activeFollowUp, _qualificationFollowUpAt = null) {
  return activeFollowUp?.nextFollowUpDate ?? null;
}

export function getNextFollowUpForLead(followUps = [], qualificationFollowUpAt = null) {
  const activeFollowUp = resolveActiveFollowUp(followUps);
  const date = resolveEffectiveFollowUpDate(activeFollowUp, qualificationFollowUpAt);
  const agenda = activeFollowUp?.agenda?.trim() || null;

  return {
    date,
    agenda,
    followUp: activeFollowUp
  };
}
